<template>
    <form class="card">
        <h3>Цены</h3>
        <div class="inline" v-if="status == '' && data.prices">
            <div class="grid">
                <div id="price">
                    <div class="inline price-header">
                        <span>1ч</span>
                        <span>12ч</span>
                        <span>24ч</span>
                    </div>
                    <div class="inline" valign="center">
                        <div class="checkbox">
                            <input type="checkbox" id="auto" v-model="data.prices[0].active" />
                            <label for="auto">Авто</label>
                        </div>
                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[0].price_1" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[0].id, field: 'price_1'})"></div>
                        </div>
                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[0].price_2" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[0].id, field: 'price_2'})"></div>

                        </div>
                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[0].price_3" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[0].id, field: 'price_3'})"></div>
                        </div>
                    </div>
                    <div class="inline" valign="center">
                        <div class="checkbox">
                            <input type="checkbox" id="jeep" v-model="data.prices[1].active" />
                            <label for="jeep">Джип</label>
                        </div>
                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[1].price_1" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[1].id, field: 'price_1'})"></div>
                        </div>

                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[1].price_2" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[1].id, field: 'price_2'})"></div>
                        </div>

                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[1].price_3" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[1].id, field: 'price_3'})"></div>
                        </div>
                    </div>
                    <div class="inline" valign="center">
                        <div class="checkbox">
                            <input type="checkbox" id="moto" v-model="data.prices[2].active" />
                            <label for="moto">Мото</label>
                        </div>
                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[2].price_1" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[2].id, field: 'price_1'})"></div>
                        </div>

                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[2].price_2" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[2].id, field: 'price_2'})"></div>
                        </div>

                        <div class="inline">
                            <input type="text" class="text-input" v-model="data.prices[2].price_3" />
                            <div class="hbutton" @click="$emit('showPopup', {popup: 'logs', type: 'price', id: data.prices[2].id, field: 'price_3'})"></div>
                        </div>
                    </div>
                </div>
                <div class="text-item">
                    <span>Дата</span>
                    <p>{{ data.ctime }}</p>
                </div>
                <div class="text-item">
                    <span>Статус</span>
                    <p>{{ data.status_text }}</p>
                </div>
            </div>
            <div class="grid">
                <div class="form-item" v-if="data.file">
                    <ZoomImage :src="data.file"/>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import ZoomImage from '@/components/ZoomImage.vue'

    export default {
        props: ['status', 'data'],
        components: {
            ZoomImage
        },
        created () {
            this.$emit('getData')
        }
    }
</script>